module.exports = __webpack_public_path__ + "assets/img/921cd92747a9a632cfb4dc3beb315259.svg";